import { getAuthToken, parseResponse, requestAuthAdmin } from './auth';

async function call(path, options = {}) {
  const response = await requestAuthAdmin(path, options, getAuthToken());
  return parseResponse(response, path);
}

export async function getAdminAccounts() {
  const body = await call('/api-admin/v0/admin-accounts');
  return body?.data || { items: [], managers: [] };
}

export async function createAdminAccount(emailAddress, username) {
  const body = await call('/api-admin/v0/admin-accounts', {
    method: 'POST',
    body: JSON.stringify({ email_address: emailAddress, username }),
  });
  return body?.data;
}

export async function setAdminAccountActive(userId, active) {
  const body = await call(`/api-admin/v0/admin-accounts/${userId}/status`, {
    method: 'PATCH',
    body: JSON.stringify({ active }),
  });
  return body?.data;
}

export async function getAdminAccountAuditLogs() {
  const body = await call('/api-admin/v0/admin-account-audit-logs?limit=100');
  return body?.data?.items || [];
}
